import moment from 'moment';

const timeFormat = 'YYYY-MM-DD HH:mm:ss';
const timestamp = moment().format(timeFormat);

export const postHogTestBuilderShown = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('test_builder');
    posthog.capture('test_builder_shown', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogTestBuilderClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('test_builder');
    posthog.capture('test_builder_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogTutorProfileBookingClicked = (posthog, data) => {
  posthog.capture('tutor_profile_booking_clicked', {
    ...data,
    timestamp,
  });
};

export const postHogTutorStrengthModalShown = (posthog, data) => {
  posthog.capture('tutor_strength_modal_shown', {
    ...data,
    timestamp,
  });
};

export const postHogTutorStrengthModalSubmitted = (posthog, data) => {
  posthog.capture('tutor_strength_modal_submitted', {
    ...data,
    timestamp,
  });
};

export const postHogBookTrialClassCtaShown = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('book_trial_class_cta');
    posthog.capture('book_trial_class_cta_shown', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogBookTrialClassCtaClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('book_trial_class_cta');
    posthog.capture('book_trial_class_cta_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogUploadButtonShown = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('Upload-button');
    posthog.capture('upload_button_shown', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogUploadButtonClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('Upload-button');
    posthog.capture('upload_button_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogAiInstantSupportClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('ai_bot_for_support');
    posthog.capture('ai_instant_support_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogWhatsAppSupportClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('ai_bot_for_support');
    posthog.capture('whatsapp_support_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogAiInstantSupportMessageSent = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('ai_bot_for_support');
    posthog.capture('ai_instant_support_message_sent', {
      ...data,
      variant,
      timestamp,
    });
  });
};

/** PostHog payloads use snake_case property names */
export const postHogTrialCancelModalViewed = (
  posthog,
  data: { classId: string; studentId: string }
) => {
  posthog.capture('trial_cancel_modal_viewed', {
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};

export const postHogTrialRescheduleModalViewed = (
  posthog,
  data: { classId: string; studentId: string }
) => {
  posthog.capture('trial_reschedule_modal_viewed', {
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};

export const postHogTrialCancelReasonSelected = (
  posthog,
  data: {
    mainReason: string;
    subReason: string;
    otherText?: string;
    classId: string;
    studentId: string;
  }
) => {
  posthog.capture('trial_cancel_reason_selected', {
    main_reason: data.mainReason,
    sub_reason: data.subReason,
    ...(data.otherText !== undefined ? { other_text: data.otherText } : {}),
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};
export const postHogTrialRescheduleReasonSelected = (
  posthog,
  data: {
    mainReason: string;
    subReason: string;
    otherText?: string;
    classId: string;
    studentId: string;
  }
) => {
  posthog.capture('trial_reschedule_reason_selected', {
    main_reason: data.mainReason,
    sub_reason: data.subReason,
    ...(data.otherText !== undefined ? { other_text: data.otherText } : {}),
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};

export const postHogTrialCancelSubmitted = (
  posthog,
  data: { classId: string; studentId: string }
) => {
  posthog.capture('trial_cancel_submitted', {
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};

export const postHogTrialRescheduleSubmitted = (
  posthog,
  data: { classId: string; studentId: string }
) => {
  posthog.capture('trial_reschedule_submitted', {
    class_id: data.classId,
    student_id: data.studentId,
    timestamp,
  });
};

export const postHogReportDownloadShown = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('performance_report_download');
    posthog.capture('performance_report_download_shown', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogReportDownloadClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('performance_report_download');
    posthog.capture('performance_report_download_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogMissedTrialBookAgainClicked = (
  posthog,
  data: {
    userId: string;
    classId: string;
    curriculum?: string;
    subject?: string;
    grade?: string;
  }
) => {
  posthog.capture('missed_trial_book_again_clicked', {
    user_id: data.userId,
    class_id: data.classId,
    ...(data.curriculum ? { curriculum: data.curriculum } : {}),
    ...(data.subject ? { subject: data.subject } : {}),
    ...(data.grade ? { grade: data.grade } : {}),
    timestamp,
  });
};

export const postHogCancelledTrialBookAgainClicked = (
  posthog,
  data: {
    userId: string;
    classId: string;
    curriculum?: string;
    subject?: string;
    grade?: string;
  }
) => {
  posthog.capture('cancelled_trial_book_again_clicked', {
    user_id: data.userId,
    class_id: data.classId,
    ...(data.curriculum ? { curriculum: data.curriculum } : {}),
    ...(data.subject ? { subject: data.subject } : {}),
    ...(data.grade ? { grade: data.grade } : {}),
    timestamp,
  });
};

export const postHogTutorScheduleButtonShown = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('tutors-schedule');
    posthog.capture('tutor_schedule_button_shown', {
      ...data,
      variant,
      timestamp,
    });
  });
};

export const postHogTutorScheduleButtonClicked = (posthog, data) => {
  posthog.onFeatureFlags(() => {
    const variant = posthog.getFeatureFlag('tutors-schedule');
    posthog.capture('tutor_schedule_button_clicked', {
      ...data,
      variant,
      timestamp,
    });
  });
};

/** User opened the Profile page (any tab). */
export const postHogProfilePageViewed = (
  posthog,
  data?: Record<string, unknown>
) => {
  if (!posthog) return;
  posthog.capture('profile_page_viewed', {
    ...(data || {}),
    timestamp,
  });
};

/**
 * Student has the Refund Request tab visible in the profile sidebar
 * (PostHog flag active). Distinct from opening the tab content.
 */
export const postHogProfileRefundTabAvailable = (
  posthog,
  data: Record<string, unknown>
) => {
  if (!posthog) return;
  posthog.capture('profile_refund_tab_available', {
    ...data,
    timestamp,
  });
};

/** User opened the Refund Request panel (content mounted). */
export const postHogProfileRefundSectionViewed = (
  posthog,
  data?: Record<string, unknown>
) => {
  if (!posthog) return;
  posthog.capture('profile_refund_section_viewed', {
    ...(data || {}),
    timestamp,
  });
};
